// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root-nK5","title":"NotFound_title-AGR","label":"NotFound_label-iij"};